<div class="dialog-wrapper">
  <div class="header">
    <span class="heading">{{ data.headerText }}</span>
    <i class="pi pi-times" (click)="onClose()"></i>
  </div>

  <div class="body">
    <div class="response-text">{{ data.body }}</div>
    <div class="response-text" *ngFor="let item of data?.bodyOptional">{{ item }}</div>
  </div>

  <div class="footer">
    <button class="btn mdlz-btn" (click)="onAgree()">{{ data.footerText }}</button>
  </div>
</div>
